/**
 * Digital Bewehrungsschieber App Block
 */
(function () {
  ("use strict");

  var ASSET_LOAD_TIMEOUT_MS = 8000;

  console.log("[SchieberWidget] Script initialized");

  /**
   * Check remote availability with detailed logs
   */
  var deac_is_remote_available = async function (url, retries = 2) {
    console.log(`[SchieberWidget] Checking availability → ${url}`);

    if (!url) {
      console.warn("[SchieberWidget] Empty URL for test");
      return false;
    }

    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        console.log(`[SchieberWidget] Attempt ${attempt}/${retries} (HEAD)`);

        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);

        const response = await fetch(url, {
          method: "HEAD",
          mode: "cors",
          credentials: "omit",
          cache: "no-store",
          signal: controller.signal,
          headers: { Accept: "*/*" },
        });

        clearTimeout(timeout);

        if (response.ok) {
          console.log(
            `[SchieberWidget] ✅ Primary accessible (status ${response.status})`,
          );
          return true;
        } else {
          console.warn(
            `[SchieberWidget] Primary responded but HTTP code ${response.status}`,
          );
          return false;
        }
      } catch (err) {
        console.warn(
          `[SchieberWidget] Attempt ${attempt} failed →`,
          err.message || err,
        );

        if (attempt === retries) {
          console.warn(
            `[SchieberWidget] ❌ Primary unavailable after ${retries} attempts`,
          );
          return false;
        }

        await new Promise((r) => setTimeout(r, 1000));
      }
    }
    return false;
  };

  // ==================== CONFIG ====================
  function getConfig() {
    const cfg = window.deacSchieberWidget || null;
    if (cfg) {
      console.log("[SchieberWidget] Configuration found", {
        jsPrimary: cfg.jsPrimary ? "✅" : "❌",
        cssPrimary: cfg.cssPrimary ? "✅" : "❌",
        hasFallback: !!(cfg.jsFallback || cfg.cssFallback),
      });
    } else {
      console.error(
        "[SchieberWidget] No configuration found (window.deacSchieberWidget)",
      );
    }
    return cfg;
  }

  function withVersion(url, version) {
    if (!version) return url;
    const sep = url.indexOf("?") >= 0 ? "&" : "?";
    return url + sep + "ver=" + encodeURIComponent(version);
  }

  // ==================== CSS ====================
  function appendStylesheet(href) {
    console.log(`[SchieberWidget] Loading CSS → ${href}`);
    return new Promise((resolve, reject) => {
      var link = document.createElement("link");
      var done = false;
      var timeoutId = setTimeout(() => {
        if (done) return;
        done = true;
        if (link.parentNode) link.parentNode.removeChild(link);
        reject(new Error("CSS timeout"));
      }, ASSET_LOAD_TIMEOUT_MS);

      link.rel = "stylesheet";
      link.href = href;
      link.onload = () => {
        if (!done) {
          done = true;
          clearTimeout(timeoutId);
          console.log(`[SchieberWidget] ✅ CSS loaded successfully`);
          resolve();
        }
      };
      link.onerror = () => {
        if (!done) {
          done = true;
          clearTimeout(timeoutId);
          console.error(`[SchieberWidget] ❌ Error loading CSS`);
          reject(new Error("stylesheet failed"));
        }
      };
      document.head.appendChild(link);
    });
  }

  async function loadStylesheetWithFallback(primary, fallback, version) {
    if (!primary) {
      console.log("[SchieberWidget] No primary CSS defined");
      return;
    }

    const primaryUrl = withVersion(primary, version);
    const primaryOk = await deac_is_remote_available(primaryUrl);

    if (primaryOk) {
      console.log("[SchieberWidget] Loading primary CSS");
      return appendStylesheet(primaryUrl);
    } else if (fallback) {
      console.warn("[SchieberWidget] Falling back to fallback CSS");
      return appendStylesheet(withVersion(fallback, version));
    } else {
      console.error("[SchieberWidget] No CSS available");
      throw new Error("CSS unavailable");
    }
  }

  // ==================== JS ====================
  function appendScript(src) {
    console.log(`[SchieberWidget] Loading JS → ${src}`);
    return new Promise((resolve, reject) => {
      var script = document.createElement("script");
      var done = false;
      var timeoutId = setTimeout(() => {
        if (done) return;
        done = true;
        if (script.parentNode) script.parentNode.removeChild(script);
        reject(new Error("JS timeout"));
      }, ASSET_LOAD_TIMEOUT_MS);

      script.async = true;
      script.src = src;
      script.onload = () => {
        if (!done) {
          done = true;
          clearTimeout(timeoutId);
          console.log(`[SchieberWidget] ✅ JS loaded successfully`);
          resolve();
        }
      };
      script.onerror = () => {
        if (!done) {
          done = true;
          clearTimeout(timeoutId);
          console.error(`[SchieberWidget] ❌ Error loading JS`);
          reject(new Error("script failed"));
        }
      };
      document.head.appendChild(script);
    });
  }

  function hasWidgetConstructor() {
    const has =
      typeof SchieberWidget === "function" ||
      (SchieberWidget && typeof SchieberWidget.default === "function") ||
      (SchieberWidget && typeof SchieberWidget.SchieberWidget === "function");

    console.log(
      `[SchieberWidget] Constructor available? ${has ? "✅ YES" : "❌ NO"}`,
    );
    return has;
  }

  function showFallbackLoadingMessage() {
    var container = document.getElementById("schieber-widget-container");
    if (!container) return;

    var existing = document.getElementById("schieber-widget-fallback-wait");
    if (existing) return;

    var waitEl = document.createElement("div");
    waitEl.id = "schieber-widget-fallback-wait";
    waitEl.style.display = "flex";
    waitEl.style.flexDirection = "column";
    waitEl.style.alignItems = "center";
    waitEl.style.justifyContent = "center";
    waitEl.style.gap = "12px";
    waitEl.style.padding = "20px";
    waitEl.style.textAlign = "center";
    waitEl.style.fontSize = "16px";
    waitEl.style.color = "#1f2937";

    var message = document.createElement("p");
    message.textContent =
      "Bitte warten, der Bewehrungsschieber wird geladen...";

    waitEl.appendChild(message);
    container.appendChild(waitEl);
  }

  function hideFallbackLoadingMessage() {
    var waitEl = document.getElementById("schieber-widget-fallback-wait");
    if (waitEl && waitEl.parentNode) {
      waitEl.parentNode.removeChild(waitEl);
    }
  }

  async function loadScriptWithFallback(primary, fallback, version) {
    if (!primary) {
      console.log("[SchieberWidget] No primary JS defined");
      return;
    }

    const primaryUrl = withVersion(primary, version);
    try {
      console.log("[SchieberWidget] Loading primary JS");
      await appendScript(primaryUrl);
    } catch (primaryError) {
      if (fallback) {
        console.warn(
          "[SchieberWidget] Primary JS failed, using fallback JS",
          primaryError,
        );
        showFallbackLoadingMessage();
        await appendScript(withVersion(fallback, version));
      } else {
        console.error("[SchieberWidget] No JS available");
        throw primaryError;
      }
    }

    hasWidgetConstructor();
  }

  // ==================== INITIALIZATION ====================
  function initSchieberWidget() {
    console.log("[SchieberWidget] Initializing widget...");
    const container = document.getElementById("schieber-widget-container");

    if (!container) {
      console.error(
        "[SchieberWidget] Container #schieber-widget-container not found",
      );
      return;
    }

    if (!hasWidgetConstructor()) {
      console.error("[SchieberWidget] SchieberWidget constructor not found");
      return;
    }

    try {
      const config = {
        containerId: "schieber-widget-container",
        theme: container.getAttribute("data-theme") || "light",
        language: container.getAttribute("data-language") || "de",
      };

      console.log("[SchieberWidget] Widget configuration:", config);

      const WidgetClass =
        typeof SchieberWidget === "function"
          ? SchieberWidget
          : SchieberWidget.default ||
            SchieberWidget.SchieberWidget ||
            SchieberWidget;

      new WidgetClass(config);
      console.log("✅ [SchieberWidget] Widget initialized successfully!");
    } catch (e) {
      console.error("❌ [SchieberWidget] Error during initialization:", e);
    } finally {
      hideFallbackLoadingMessage();
    }
  }

  // ==================== MAIN ====================
  async function loadAssetsThenInit() {
    console.log("[SchieberWidget] Starting asset loading...");
    const cfg = getConfig();

    if (!cfg || !cfg.jsPrimary) {
      console.error(
        "[SchieberWidget] Incomplete configuration (jsPrimary missing)",
      );
      return;
    }

    try {
      await loadStylesheetWithFallback(
        cfg.cssPrimary,
        cfg.cssFallback,
        cfg.assetVersion,
      );
      await loadScriptWithFallback(
        cfg.jsPrimary,
        cfg.jsFallback,
        cfg.assetVersion,
      );
      initSchieberWidget();
    } catch (err) {
      console.error("❌ [SchieberWidget] Global asset load failure:", err);
      hideFallbackLoadingMessage();
    }
  }

  function boot() {
    console.log("[SchieberWidget] Boot launched");
    if (document.getElementById("schieber-widget-container")) {
      loadAssetsThenInit();
    } else {
      console.warn("[SchieberWidget] Container not found on boot");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", showFallbackLoadingMessage);
    document.addEventListener("DOMContentLoaded", boot);
    console.log("[SchieberWidget] Waiting for DOMContentLoaded...");
  } else {
    showFallbackLoadingMessage();
    boot();
  }
})();
